
import {
  SAVE_DOCUMENT_URL,

  SAVE_PENDING_DOC,
  SAVE_SIGNED_DOC,
  SAVE_SIGNED_DOC_RESP,
  SAVE_DOC_IS_LOCKED,
  SAVE_IS_CLIENT_FILLABLE
} from '../actions/types';

const initialState = {
  signedDoc: {},
  pendingDoc: {},

  documentViewUrl: null,
  saveSignedDocResp: {},
  docIsLocked: false,
  isClientFillable: false
};

export const DocumentReducer = (state = initialState, action: any) => {
  const oldState = { ...state };
  const { type, payload } = action;
  switch (action.type) {
    case SAVE_SIGNED_DOC:
      return {
        ...state,
        signedDoc: payload,
      };

    case SAVE_PENDING_DOC:
      return {
        ...state,
        pendingDoc: payload,
      };

    case SAVE_DOCUMENT_URL:
      return {
        ...state,
        documentViewUrl: payload,
      };

    case SAVE_SIGNED_DOC_RESP:
      return {
        ...state,
        saveSignedDocResp: payload,
      };

    case SAVE_DOC_IS_LOCKED:
      return {
        ...state,
        docIsLocked: payload
      }

    case SAVE_IS_CLIENT_FILLABLE:
      return {
        ...state,
        isClientFillable: payload
      }

    default:
      return { ...state };
  }
};
